import type { TFunction } from 'i18next';

import {
  Check,
  MoneyBillTransfer,
  MoneyCheckPen,
  RocketLaunch,
  Xmark,
} from '@unified-checkout/design-system/icons/index';

import { TRANSFERS_STATUS } from '..';

export const TRANSFER_BADGES = (t: TFunction) => ({
  [TRANSFERS_STATUS.SETTLED]: {
    color: 'green',
    icon: Check,
    text: t('innerLayout.balanceTransfers.status.settled'),
  },
  [TRANSFERS_STATUS.INITIATED]: {
    color: 'primary',
    icon: RocketLaunch,
    text: t('innerLayout.balanceTransfers.status.initiated'),
  },
  [TRANSFERS_STATUS.ON_ITS_WAY]: {
    color: 'primary',
    icon: MoneyBillTransfer,
    text: t('innerLayout.balanceTransfers.status.onItsWay'),
  },
  [TRANSFERS_STATUS.IN_REVIEW]: {
    color: 'primary',
    icon: MoneyCheckPen,
    text: t('innerLayout.balanceTransfers.status.inReview'),
  },
  [TRANSFERS_STATUS.FAILED]: {
    color: 'red',
    icon: Xmark,
    text: t('innerLayout.balanceTransfers.status.failed'),
    keepIconDefaultColors: true,
  },
  [TRANSFERS_STATUS.REJECT_INSTANT]: {
    color: 'red',
    icon: Xmark,
    text: t('innerLayout.balanceTransfers.status.rejectInstant'),
    keepIconDefaultColors: true,
  },
  [TRANSFERS_STATUS.RETURNED_BY_BANK]: {
    color: 'red',
    icon: Xmark,
    text: t('innerLayout.balanceTransfers.status.failed'),
    keepIconDefaultColors: true,
  },
});

export const DRAWER_BADGE_STATUS_COLORS = {
  [TRANSFERS_STATUS.SETTLED]: 'green',
  [TRANSFERS_STATUS.FAILED]: 'red',
  [TRANSFERS_STATUS.REJECT_INSTANT]: 'red',
  [TRANSFERS_STATUS.INITIATED]: 'primary',
  [TRANSFERS_STATUS.IN_REVIEW]: 'primary',
  [TRANSFERS_STATUS.ON_ITS_WAY]: 'primary',
} as const;
